<template>
  <header class="alice-topbar">
    <div class="alice-topbar__brand">
      <span class="alice-topbar__mark" />
      <span class="alice-topbar__wordmark">Alice</span>
    </div>

    <div class="alice-topbar__breadcrumb">
      <slot name="breadcrumb">
        <span class="alice-topbar__crumb alice-topbar__crumb--default"
          >UX Research · Valsplat</span
        >
      </slot>
    </div>

    <div class="alice-topbar__spacer" />

    <nav class="alice-topbar__nav">
      <a
        href="#"
        class="alice-topbar__link alice-topbar__link--muted"
        @click.prevent="$router.push('/profile')"
        >My profile</a
      >
      <a href="#" class="alice-topbar__link" @click.prevent="signOut"
        >Sign out</a
      >
      <Avatar
        :name="userName"
        :photo="userPhoto"
        :color="ownerColor"
        :size="32"
      />
    </nav>
  </header>
</template>

<script>
import { mapState } from "vuex";
import Avatar from "./Avatar.vue";
import { colorForOwner } from "./normalize";

export default {
  name: "AliceTopBar",
  components: { Avatar },
  computed: {
    ...mapState({ user: (s) => s.user }),
    userName() {
      return this.user?.displayName || this.user?.email || "";
    },
    userPhoto() {
      return this.user?.photoURL || "";
    },
    ownerColor() {
      return colorForOwner(this.userName);
    },
  },
  methods: {
    signOut() {
      this.$store.dispatch("signOut");
    },
  },
};
</script>

<style scoped>
.alice-topbar {
  height: 56px;
  background: var(--vp-black);
  color: var(--vp-white);
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid var(--vp-black);
  flex-shrink: 0;
}
.alice-topbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.alice-topbar__mark {
  width: 22px;
  height: 22px;
  background: var(--accent-100);
  display: inline-block;
  flex-shrink: 0;
}
.alice-topbar__wordmark {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 22px;
  letter-spacing: -0.01em;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-thickness: 2px;
  text-decoration-color: var(--accent-100);
}
.alice-topbar__breadcrumb {
  margin-left: 8px;
  padding-left: 12px;
  border-left: 1px solid var(--vp-grijs-160);
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-family: var(--font-ui);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vp-grijs-80);
}
.alice-topbar__crumb--default {
  font-weight: 400;
  letter-spacing: 0.08em;
}
.alice-topbar__spacer {
  flex: 1;
}
.alice-topbar__nav {
  display: flex;
  align-items: center;
  gap: 24px;
}
.alice-topbar__link {
  color: var(--vp-white);
  text-decoration: none;
  font-family: var(--font-ui);
  font-size: 14px;
  font-weight: 600;
}
.alice-topbar__link--muted {
  opacity: 0.85;
}
.alice-topbar__link:hover {
  opacity: 1;
  text-decoration: underline;
  text-underline-offset: 4px;
}

@media (max-width: 1279px) {
  .alice-topbar__eyebrow {
    display: none;
  }
}
</style>
